import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";

function ClassWorkSetup() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const teacherId = localStorage.getItem("userId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      subject: "",
      description: "",
      classSectionId: "",
      sectionSubjectId: "",
      classTeacherId: localStorage.getItem("userId"),
      fileName: "",
      filePath: "",
      base64String: "",
      createdBy: localStorage.getItem("userId"),
    },
  });

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [classWorksData, setClassWorksData] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [classSectionsData, setClassSectionsData] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    const fetchClassWorks = async () => {
      try {
        const response = await get(
          `MobileApp/GetMobileAppClassWork?id=${teacherId}&isTeacher=${true}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setClassWorksData(response?.dailyDiary);
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchClassWorks();
  }, [triggerRerender]);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );

          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });

            fetchClassSectionsByCenterId(savedCenterId);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
  }, []);

  const fetchClassSectionsByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassSectionsData(response);
      } else {
        setClassSectionsData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchSubjectsByClassSectionId = async (classSectionId) => {
    try {
      const response = await get(
        `StudentEvaluation/GetSubjectByClassSectionId?ClassSectionId=${classSectionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSubjectsData(response.subjects || []); // Update subjects state
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Title",
      selector: (row) => row.subject,
      sortable: true,
      width: "150px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      width: "300px",
    },
    // {
    //   name: "Action",
    //   width: "80px",
    //   selector: (row) => (
    //     <div className="d-flex gap-1">
    //       <button
    //         type="button"
    //         className="btn p-0"
    //         // onClick={() => handleEdit(row)}
    //       >
    //         <i className="fas fa-pencil"></i>
    //       </button>
    //       <button
    //         type="button"
    //         className="btn p-0"
    //         // onClick={() => handleDelete(row.id)}
    //       >
    //         <i className="fas fa-trash"></i>
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formdata = {
      ...data,
      classSectionId: data.classSectionId.value,
      sectionSubjectId: data.sectionSubjectId.value,
      fileName: fileName,
    };

    // console.log(formdata);
    // return;

    try {
      const response = await post("MobileApp/AddMobileAppClassWork", formdata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          // centerId: "",
          subject: "",
          description: "",
          classSectionId: "",
          sectionSubjectId: "",
          classTeacherId: localStorage.getItem("userId"),
          fileName: "",
          filePath: "",
          base64String: "",
          createdBy: localStorage.getItem("userId"),
        });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFileName(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("base64String", base64String, { shouldValidate: true });
        // setPreviewUrl(reader.result);
        trigger("fileName");
      };
      reader.readAsDataURL(file);
    } else {
      // setPreviewUrl(null);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading mb-2 fs-7">Classwork</h2>
      </div>
      <div className="row g-3">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit(saveData)}>
                <div className="col-md-4">
                  <label className="form-label">
                    Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("centerId", null);
                            setValue("classSectionId", null);
                            setValue("sectionSubjectId", null);
                            setClassSectionsData([]);
                            setSubjectsData([]);
                          } else {
                            setValue("centerId", selectedOption);
                            setValue("classSectionId", null);
                            setCenterId(selectedOption.value);
                            fetchClassSectionsByCenterId(selectedOption.value);
                          }
                          trigger("centerId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Class - Section<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="classSectionId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classSectionsData.map((classSection) => ({
                          value: classSection.id,
                          label: classSection.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("classSectionId", null);
                            setSubjectsData([]);
                            setValue("sectionSubjectId", null);
                          } else {
                            setValue("classSectionId", selectedOption);
                            fetchSubjectsByClassSectionId(selectedOption.value);
                          }
                          trigger("classSectionId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.classSectionId && (
                    <small className="text-danger">
                      {errors.classSectionId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Subject<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`sectionSubjectId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subjectsData.map((subject) => ({
                          value: subject.id,
                          label: subject.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("sectionSubjectId", null);
                          } else {
                            setValue("sectionSubjectId", selectedOption);
                          }
                          trigger("sectionSubjectId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.sectionSubjectId && (
                    <small className="text-danger">
                      {errors.sectionSubjectId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Title<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`subject`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("subject")}
                  />
                  {errors.subject && (
                    <small className="text-danger">
                      {errors.subject.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    File Attachment
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
                    {/* <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1">
                      {previewUrl ? (
                        <img src={previewUrl} alt="Preview" />
                      ) : (
                        <div>
                          <span className="fas fa-image fs-3 text-light"></span>
                        </div>
                      )}
                    </div> */}
                    <input
                      {...register("fileName")}
                      type="file"
                      className="form-control"
                      // accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  {errors.fileName && (
                    <small className="text-danger">
                      {errors.fileName.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">Description</label>
                  <input
                    {...register(`description`, {
                      maxLength: {
                        value: 250,
                        message: "Maximum of 250 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("description")}
                  />
                  {errors.description && (
                    <small className="text-danger">
                      {errors.description.message}
                    </small>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={classWorksData}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClassWorkSetup;
